(function () {
    'use strict';

    let timeoutID;

    run.admin.parts.rackootViewUnloggedInviteMessage = function() {
        if (document.body.classList.contains('user_logged_in') != true) {
            timeoutID = setTimeout(() => {
                modal_register_invitation();
            }, 10000);
        }

        function modal_register_invitation()
        {
            const html = translations.inviteMessage.messages.title+`
                <div class="mt-4">
                    <a class="btn btn-lg btn-primary" href="`+GlobalRoutes.auth.register+`">`+translations.inviteMessage.messages.buttonRegister+`</a>
                    <a class="btn btn-lg btn-primary" href="`+GlobalRoutes.auth.login+`">`+translations.inviteMessage.messages.buttonLogIn+`</a>
                </div>
            `;
            Swal.fire({
                title: null,
                html: html,
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            }).then((result) => {
            });
        }

        const btn_add_tile_not_logged = document.getElementById('btn_add_tile__not_logged');
        if (btn_add_tile_not_logged !== null) {
            btn_add_tile_not_logged.addEventListener('click', function(e) {
                clearTimeout(timeoutID);
                const rackoot_data = document.getElementById('rackoot_data');
    
                const html = translations.inviteMessage.messages.addTileNotLogged+`
                    <div class="mt-4">
                        <a class="btn btn-lg btn-primary" href="`+GlobalRoutes.auth.register+`?origin=add_public_tile&rackoot_id=`+rackoot_data.dataset.uuid+`">`+translations.inviteMessage.messages.buttonRegister+`</a>
                    </div>
                `;
                Swal.fire({
                    title: null,
                    html: html,
                    showCloseButton: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                    showClass: {
                        popup: 'animate__animated animated__fast animate__fadeInUp'
                    },
                    hideClass: {
                        popup: 'animate__animated animated__fast animate__fadeOutDown'
                    }
                }).then((result) => {
                });
            });
        }
    }
})();
